module.exports = __webpack_public_path__ + "img/researching.2b2b2101.svg";